import { combineReducers } from 'redux';

import countByType from './countByType';
import createModal from './CreateModal';
import dashboard from './dashboard';
import details from './details';
import filters from './filters';
import mediasLists from './mediasLists';

/**
 * @typedef {{
 *  createModal: import('./CreateModal').ChatUiModalCreateReducer,
 *  details: import('./details').ChatUIDetailsReducer,
 *  filters: import('./filters').ChatUIFiltersReducer,
 *  dashboard: import('./dashboard').ChatUiDashboardReducer,
 *  mediasLists: import('./mediasLists').ConversationMediaListReducer,
 *  countByType: import('./countByType').ChatUiCountByTypeReducer,
 * }} ChatUIReducer
 */

export default combineReducers({
  // Specific ui slice
  details,
  dashboard,
  // Shared
  filters,
  mediasLists,
  countByType,
  createModal,
});
